import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ ResizeObserver error suppress (global fix)
const originalError = console.error;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("ResizeObserver loop")
  ) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // ❌ StrictMode remove kiya (optional but recommended for this issue)
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();